module.exports = __webpack_public_path__ + "img/partner1.223a67da.jpg";